import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import toastr from "toastr"

import { EventDataResponse } from "types"

/**
 * Custom hook for fetching event details based on bundle UUID
 * @param bundleUUID - The bundle UUID to fetch event details for
 * @param options - Additional query options
 * @returns Query result with event data, loading state, and error
 */
export const useEventData = (
  bundleUUID: string | undefined,
  options?: { enabled?: boolean }
) => {
  return useQuery<EventDataResponse>({
    queryKey: ["eventDetails", bundleUUID],
    queryFn: async () => {
      try {
        const response = await axios.get<EventDataResponse>(
          `api/registration/details-published/?bundle__uuid=${bundleUUID}`
        )
        return response.data
      } catch (error) {
        toastr.error("Failed to fetch event data")
        console.error("error fetching event data")
        throw error
      }
    },
    enabled: !!bundleUUID && options?.enabled !== false,
  })
}
